import { __awaiter, __generator } from "tslib";
var CdnApiClient = /** @class */ (function () {
    function CdnApiClient(opts) {
        this.cdnUrl = (opts.baseCdnUrl || 'https://settings.parastorage.com/').replace(/\/$/, '');
        this.fetch = opts.fetch || (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return fetch.apply(void 0, args);
        }); // https://stackoverflow.com/a/72800505
    }
    CdnApiClient.prototype.get = function (appDefId, instanceId, externalId, scope) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.cdnUrl, "/v1/settings/").concat(appDefId, "/").concat(instanceId, "/").concat(scope, "/").concat(externalId);
                        return [4 /*yield*/, this.fetch(url, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CdnApiClient;
}());
export { CdnApiClient };
//# sourceMappingURL=cdn-api-client.js.map